'use client'
import { ChevronRightIcon } from '@repo/ui/ChevronRightIcon'
import { MicrosoftLogo } from '@repo/ui/MicrosoftLogo'
import { useKeyDateStore } from '@repo/store/useKeyDateStore'
import MUIButton from '@mui/material/Button'
import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'

const OutlookSetup = () => {
  const { fetchOutlookAuthUrl } = useKeyDateStore()

  const handleClick = async () => {
    const authUrl = await fetchOutlookAuthUrl()
    location.replace(authUrl)
  }

  return (
    <MUIStack
      data-testid="OutlookSetup"
      gap={6}
      sx={{ maxWidth: 680, margin: 'auto', backgroundColor: 'white', borderRadius: '6px', padding: '60px 40px' }}
    >
      <MicrosoftLogo sx={{ width: '220px', height: 'auto', marginBottom: 3 }} />
      <MUITypography variant="body1">
        {`This screen enables you to set up a Microsoft Outlook integration, which will allow you to sync Key Dates to your Outlook calendar.`}
      </MUITypography>

      <MUITypography variant="body1">
        {`When you click the button below, you'll be redirected to a Microsoft login page. You'll need to grant permission to the Microsoft Graph API. Once you've done that, you'll be redirected back to Osprey.`}
      </MUITypography>
      <MUIButton
        variant="contained"
        color="primary"
        size="large"
        onClick={handleClick}
        sx={{ maxWidth: 160, width: '100%', margin: '20px 0 0 auto' }}
      >
        Start
        <ChevronRightIcon sx={{ color: 'white' }} />
      </MUIButton>
    </MUIStack>
  )
}

export default OutlookSetup
